import { CONTACT_SVC } from 'rainbow-web-sdk/services/core/contact.service';
import { MAIN_SVC } from 'rainbow-web-sdk/services/core/main.service';
import { PROFILE_SVC } from 'rainbow-web-sdk/services/core/profile.service';
import { XMPP_SVC } from 'rainbow-web-sdk/services/core/xmpp.service';
import { PRESENCE_HELPER_SVC } from 'rainbow-web-sdk/services/core/presenceHelper.service';
import { FILE_SERVER_SVC } from 'rainbow-web-sdk/services/files/fileServer.service';
import { FILE_STORAGE_SVC } from 'rainbow-web-sdk/services/files/fileStorage.service';
import { BUBBLE_SVC } from 'rainbow-web-sdk/services/bubbles/bubble.service';
import { CONVERSATION_SVC } from 'rainbow-web-sdk/services/conversation/conversation.service';
import { CALL_LOG_SVC } from 'rainbow-web-sdk/services/callLog/callLog.service';
import { FAVORITES_SVC } from 'rainbow-web-sdk/services/favorites/favorites.service';
import { USERSLISTS_SVC } from 'rainbow-web-sdk/services/users/usersLists.service';
import { WEBRTC_P2P_SVC } from 'rainbow-web-sdk/services/webrtc';
import { WEBRTC_GATEWAY_SVC } from 'rainbow-web-sdk/services/webrtcGateway/webrtcGateway.service';
import { TELEPHONY_SVC } from 'rainbow-web-sdk/services/telephony';
import { TELEPHONYCONFIG_SVC } from 'rainbow-web-sdk/services/telephonyConfig';
import { DATA_CHANNEL_SVC } from 'rainbow-web-sdk/services/dataChannel';
import { DIRECTORY_SEARCH_SVC } from 'rainbow-web-sdk/services/directory';
import { PERSONAL_DIRECTORY_SVC } from 'rainbow-web-sdk/services/directory/personal-directory.service';
import { WEBINAR_SVC } from 'rainbow-web-sdk/services/webinars/webinars.service';
import { BUBBLE_CONFERENCE_SVC } from '../../conference';
import { DEVICE_MANAGEMENT_SVC } from '../../deviceManagement/deviceManagement.service';
import { BUBBLE_TAG_SVC } from '../../bubbles/bubbleTag.service';
import { LIVE_TRANSCRIPTION_SVC } from '../../transcription/liveTranscription.service';
import { CONFERENCE_RECAP_SVC } from '../../conference/bubbleConferenceRecap.service';
import { FILEDOCUMENT_SVC } from '../../fileDocument/fileDocument.service';
import { CHANNEL_SVC } from 'rainbow-web-sdk/services/channels/channel.service';
import { CALL_RECORDER_SVC } from '../../call/callRecorder.service';
import { TELEMETRY_SVC } from '../../telemetry';
import { WEBINAR_TELEMETRY_SVC } from '../../webinars/telemetry/webinarTelemetry.service';

export class SdkLaunchConfig {

    private constructor() { }

    public static create(): SdkLaunchConfig { return new SdkLaunchConfig(); }

    public getStartServices(): any[] {
        return [
            { name: XMPP_SVC, action: 'start', sync: true, blocking: true },
            { name: CONTACT_SVC, action: 'start', sync: true, blocking: true },
            { name: PROFILE_SVC, action: 'start', sync: true, blocking: true },
            { name: FILE_SERVER_SVC, action: 'start' },
            { name: FILE_STORAGE_SVC, action: 'start' },
            { name: FILEDOCUMENT_SVC, action: 'start' },
            { name: BUBBLE_SVC, action: 'start', sync: true, blocking: true },
            { name: BUBBLE_TAG_SVC, action: 'start' },
            { name: TELEMETRY_SVC, action: 'start' },
            { name: CONTACT_SVC, action: 'sendPresenceFromConfiguration', deps: [true], sync: true, blocking: true },
            { name: MAIN_SVC, action: 'configure', deps: ['centralizedService'] },
            { name: PRESENCE_HELPER_SVC, action: 'start', blocking: true },
            { name: CONVERSATION_SVC, action: 'start', sync: true, blocking: true },
            { name: CONFERENCE_RECAP_SVC, action: 'start' },
            { name: CALL_LOG_SVC, action: 'start' },
            { name: FAVORITES_SVC, action: 'start' },
            { name: USERSLISTS_SVC, action: 'start' },
            { name: WEBRTC_P2P_SVC, action: 'start' },
            { name: WEBINAR_SVC, action: 'start' },
            { name: WEBINAR_TELEMETRY_SVC, action: 'start' },
            { name: TELEPHONY_SVC, sync: true, action: 'start' },
            { name: WEBRTC_GATEWAY_SVC, sync: true, action: 'start' },
            { name: CALL_RECORDER_SVC, action: 'start' },
            { name: TELEPHONYCONFIG_SVC, action: 'start' },
            { name: BUBBLE_CONFERENCE_SVC, action: 'start' },
            { name: DATA_CHANNEL_SVC, action: 'start' },
            { name: LIVE_TRANSCRIPTION_SVC, action: 'start' },
            { name: DIRECTORY_SEARCH_SVC, action: 'start' },
            { name: PERSONAL_DIRECTORY_SVC, action: 'start' },
            { name: DEVICE_MANAGEMENT_SVC, action: 'start' },
            { name: CHANNEL_SVC, action: 'start' },
            { name: 'launcherService', action: 'start' }
        ];
    }

    public getStopServices(): any[] {
        return [
            { name: XMPP_SVC, action: 'stop' },
            { name: PROFILE_SVC, action: 'stop' },
            { name: BUBBLE_SVC, action: 'stop' },
            { name: BUBBLE_TAG_SVC, action: 'stop' },
            { name: FILEDOCUMENT_SVC, action: 'stop' },
            { name: FILE_STORAGE_SVC, action: 'stop' },
            { name: CONTACT_SVC, action: 'stop' },
            { name: PRESENCE_HELPER_SVC, action: 'stop' },
            { name: CONVERSATION_SVC, action: 'stop' },
            { name: CONFERENCE_RECAP_SVC, action: 'stop' },
            { name: CALL_LOG_SVC, action: 'stop' },
            { name: FAVORITES_SVC, action: 'stop' },
            { name: USERSLISTS_SVC, action: 'stop' },
            { name: WEBRTC_P2P_SVC, action: 'stop' },
            { name: WEBINAR_SVC, action: 'stop' },
            { name: TELEPHONY_SVC, action: 'stop' },
            { name: TELEPHONYCONFIG_SVC, action: 'stop' },
            { name: WEBRTC_GATEWAY_SVC, action: 'stop' },
            { name: CALL_RECORDER_SVC, action: 'stop' },
            { name: BUBBLE_CONFERENCE_SVC, action: 'stop' },
            { name: DATA_CHANNEL_SVC, action: 'stop' },
            { name: LIVE_TRANSCRIPTION_SVC, action: 'stop' },
            { name: DIRECTORY_SEARCH_SVC, action: 'stop' },
            { name: PERSONAL_DIRECTORY_SVC, action: 'stop' },
            { name: DEVICE_MANAGEMENT_SVC, action: 'stop' },
            { name: CHANNEL_SVC, action: 'stop' },
            { name: TELEMETRY_SVC, action: 'stop' },
            { name: WEBINAR_TELEMETRY_SVC, action: 'stop' }
        ];
    }

    public getReconnectServices(): any[] {
        return [
            { name: BUBBLE_SVC, action: 'reconnect' },
            { name: BUBBLE_TAG_SVC, action: 'reconnect' },
            { name: CONTACT_SVC, action: 'reconnect' },
            { name: FILEDOCUMENT_SVC, action: 'reconnect' },
            { name: FILE_SERVER_SVC, action: 'reconnect' },
            { name: PROFILE_SVC, action: 'reconnect' },
            { name: FILE_STORAGE_SVC, action: 'reinit', deps: [false] },
            { name: PRESENCE_HELPER_SVC, action: 'resendPresenceAfterReconnect' },
            { name: CONVERSATION_SVC, action: 'reconnect' },
            { name: FAVORITES_SVC, action: 'reconnect' },
            { name: USERSLISTS_SVC, action: 'reconnect' },
            { name: WEBRTC_P2P_SVC, action: 'reconnect' },
            { name: TELEPHONY_SVC, action: 'reconnect' },
            { name: TELEPHONYCONFIG_SVC, action: 'reconnect' },
            { name: WEBINAR_SVC, action: 'reconnect' },
            { name: LIVE_TRANSCRIPTION_SVC, action: 'reconnect' },
            { name: CONFERENCE_RECAP_SVC, action: 'reconnect' },
            { name: CHANNEL_SVC, action: 'reconnect' },
            { name: 'launcherService', action: 'reconnect' }
        ];
    }
}
